var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _path2, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 360,
    viewBox: "0 0 520 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 360,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H500C511.046 0 520 8.95431 520 20V230L0 140V20Z",
    fill: "url(#paint0_linear_2368_2284)",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 366.5,
    y: 102.5,
    width: 73,
    height: 127,
    fill: "#2E73C3",
    stroke: "#333333",
    strokeWidth: 7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 393,
    y: 111,
    width: 20,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 111,
    width: 8,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 111,
    width: 8,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 371.973,
    y: 120.267,
    width: 62.0477,
    height: 1,
    fill: "white",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 123.414,
    width: 6.3314,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 135.501,
    width: 6.3314,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 380.402,
    y: 123.414,
    width: 20.1453,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 380.402,
    y: 135.501,
    width: 24.1744,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 425.203,
    y: 123.414,
    width: 8.05814,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 425.203,
    y: 135.501,
    width: 8.05814,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 132.355,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 144.442,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 147.972,
    width: 6.3314,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 160.059,
    width: 6.3314,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 380.402,
    y: 147.972,
    width: 20.1453,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 380.402,
    y: 160.059,
    width: 24.1744,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 425.203,
    y: 147.972,
    width: 8.05814,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 425.203,
    y: 160.059,
    width: 8.05814,
    height: 6.13953,
    rx: 3.06977,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 156.913,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 169,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 171.302,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 177.346,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 183.39,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 189.433,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 171.302,
    width: 20.1453,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 177.346,
    width: 16.1163,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 183.39,
    width: 24.1744,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 189.433,
    width: 20.1453,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 171.302,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 177.346,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 183.39,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 189.433,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 175.734,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 181.778,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 187.822,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 193.865,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 195.86,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 201.904,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 207.948,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 372.379,
    y: 213.991,
    width: 4.02907,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 195.86,
    width: 20.1453,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 201.904,
    width: 16.1163,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 207.948,
    width: 24.1744,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 379.637,
    y: 213.991,
    width: 20.1453,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 195.86,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 201.904,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 207.948,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 425.969,
    y: 213.991,
    width: 8.05814,
    height: 3.22325,
    rx: 1.61163,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 200.292,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 206.336,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 212.38,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 371.973,
    y: 218.423,
    width: 62.0477,
    height: 1,
    fill: "white"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 393.789,
    y: 69,
    width: 18,
    height: 30,
    fill: "#666666"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 95,
    width: 250,
    height: 145,
    fill: "#2E73C3",
    stroke: "#333333",
    strokeWidth: 10
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 70,
    width: 30,
    height: 20,
    fill: "#666666"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 70,
    width: 30,
    height: 20,
    fill: "#666666"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 50,
    width: 458,
    height: 20,
    fill: "#555555"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 175.5,
    y: 106,
    width: 75,
    height: 9,
    rx: 4.5,
    fill: "white"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 106,
    width: 30,
    height: 9,
    rx: 4.5,
    fill: "white"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 136,
    width: 15,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 158.5,
    width: 15,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 181,
    width: 15,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 203.5,
    width: 15,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 136,
    width: 75,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 158.5,
    width: 60,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 181,
    width: 90,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 203.5,
    width: 75,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 136,
    width: 30,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 158.5,
    width: 30,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 181,
    width: 30,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 203.5,
    width: 30,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 106,
    width: 30,
    height: 9,
    rx: 4.5,
    fill: "white"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 130,
    width: 231,
    height: 1.5,
    fill: "white",
    fillOpacity: 0.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 97.5,
    y: 152.5,
    width: 231,
    height: 1.5,
    fill: "white"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 97.5,
    y: 175,
    width: 231,
    height: 1.5,
    fill: "white"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 97.5,
    y: 197.5,
    width: 231,
    height: 1.5,
    fill: "white"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 97.5,
    y: 220,
    width: 231,
    height: 1.5,
    fill: "white"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 215,
    width: 166,
    height: 96,
    fill: "#2E73C3",
    stroke: "#333333",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233 314H433V314C433 319.523 428.523 324 423 324H243C237.477 324 233 319.523 233 314V314Z",
    fill: "#C4C4C4"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 222,
    width: 50,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 222,
    width: 20,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 242,
    width: 10,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 257,
    width: 10,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 272,
    width: 10,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 287,
    width: 10,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 242,
    width: 50,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 257,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 272,
    width: 60,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 287,
    width: 50,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 242,
    width: 20,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 257,
    width: 20,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 272,
    width: 20,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 287,
    width: 20,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 222,
    width: 20,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 256,
    y: 238,
    width: 154,
    height: 1,
    fill: "white"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 256,
    y: 253,
    width: 154,
    height: 1,
    fill: "white"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 256,
    y: 268,
    width: 154,
    height: 1,
    fill: "white"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 256,
    y: 283,
    width: 154,
    height: 1,
    fill: "white"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 256,
    y: 298,
    width: 154,
    height: 1,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2368_2284",
    x1: 260,
    y1: 0,
    x2: 260,
    y2: 275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AC9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMonitor);
export default __webpack_public_path__ + "static/media/create-monitor.f8740c99a2f2cfec5ed0aaaa464fa395.svg";
export { ForwardRef as ReactComponent };